export const T = {
  en_GB: {
    noExistingPortfolio: "No existing portfolio",
    coverageNote: (pct: string) =>
      `Only ${pct} % of the existing portfolio has been analysed due to missing data.`,
    oneTimeOnly: "The cost/benefit comparison is only available for one-time portfolios.",
    completeRiskAssessment:
      "Please complete the risk assessment to see the cost/benefit comparison.",
    enterInvestmentAmount: "Please enter an investment amount to see the cost/benefit comparison.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see the cost/benefit comparison.`,
    noProducts:
      "No products added yet. Use the Custom Portfolio Builder to add products, then the cost/benefit comparison will be available.",
    notAvailable:
      "Cost/benefit data is not available for this portfolio yet. It is calculated once the portfolio has a composition.",
    snapshotMissing: "Cost/benefit data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading cost/benefit data. Please refresh the page.",
  },
  nb_NO: {
    noExistingPortfolio: "Ingen eksisterende portefølje",
    coverageNote: (pct: string) =>
      `Kun ${pct} % av den eksisterende porteføljen er analysert på grunn av manglende data.`,
    oneTimeOnly: "Kost/nytte-sammenligningen er bare tilgjengelig for engangsporteføljer.",
    completeRiskAssessment: "Fullfør risikovurderingen for å se kost/nytte-sammenligningen.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se kost/nytte-sammenligningen.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se kost/nytte-sammenligningen.`,
    noProducts:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter, deretter vil kost/nytte-sammenligningen være tilgjengelig.",
    notAvailable:
      "Kost/nytte-data er ikke tilgjengelig for denne porteføljen ennå. Den beregnes når porteføljen har en sammensetning.",
    snapshotMissing: "Kost/nytte-data må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av kost/nytte-data. Oppdater siden.",
  },
} as const;
